module.exports = __webpack_public_path__ + "9bb46ea34b41929a9a96b7387e024f44.svg";